<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { Heading } from "@getprovi/craft-svelte";

  export let mobileMode: boolean;
  export let authStatus: string;
</script>

{#if authStatus == "invalid"}
  <div class="fizz-inset-vertical-24 margin-container" style="min-height: 55vh">
    <div class="fizz-flex-row fizz-justify-center fizz-stack-16">
      <div class="fizz-radius-round" style="width: 40px; height: 40px; background-color: #FDE7BA">
        <div style="position: relative; top: 10px; left: 10px;">
          <Icon type="Alert" width="20" height="20" />
        </div>
      </div>
    </div>

    {#if mobileMode}
      <div class="craft fizz-margin-auto fizz-text-center" style="max-width: 270px">
        <p class="fizz-heading-4 fizz-stack-24">
          <slot name="invalid-title" />
        </p>

        <p class="fizz-stack-24">
          <slot name="invalid-description" />
        </p>

        <slot name="invalid-mobile-buttons" />
      </div>
    {:else}
      <div class="fizz-flex-row fizz-justify-center fizz-stack-16">
        <div class="fizz-heading-4"><slot name="invalid-title" /></div>
      </div>

      <div class="fizz-flex-row fizz-justify-center fizz-stack-24 fizz-text-center">
        <div>
          <slot name="invalid-description" />
        </div>
      </div>

      <div class="craft fizz-flex-row fizz-justify-center fizz-stack-64">
        <slot name="invalid-buttons" />
      </div>
    {/if}
  </div>
{:else if authStatus == "pending"}
  <div class="fizz-inset-vertical-24 margin-container" style="min-height: 55vh">
    <div class="fizz-flex-row fizz-justify-center fizz-stack-16">
      <div>
        <Icon type="Containers" width="148" height="124" />
      </div>
    </div>

    {#if mobileMode}
      <div class="fizz-text-center">
        <div class="craft fizz-stack-24">
          <Heading as="h3" class="" size="h3"><slot name="pending-title" /></Heading>
        </div>

        <p class="fizz-stack-24">
          <slot name="pending-description" />
        </p>

        <div class="fizz-flex-row fizz-justify-center">
          <span class="craft">
            <slot name="pending-buttons" />
          </span>
        </div>
      </div>
    {:else}
      <div class="fizz-flex-row fizz-justify-center fizz-stack-16">
        <span class="craft">
          <Heading as="h3" class="" size="h3"><slot name="pending-title" /></Heading>
        </span>
      </div>

      <div class="fizz-flex-row fizz-justify-center fizz-stack-24">
        <div>
          <slot name="pending-description" />
        </div>
      </div>

      <div class="fizz-flex-row fizz-justify-center fizz-stack-64">
        <div class="craft">
          <slot name="pending-buttons" />
        </div>
      </div>
    {/if}
  </div>
{/if}
